import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";
import { settingsAPI } from "../../services/api";

export default function PopupBanner() {
  const [bannerUrl, setBannerUrl] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    settingsAPI
      .get()
      .then((res) => {
        const url = res.data?.data?.settings?.popupBanner?.url;
        if (url) {
          setBannerUrl(url);
          setVisible(true);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4"
          onClick={() => setVisible(false)}
        >
          <motion.div
            key="popup-card"
            initial={{ opacity: 0, scale: 0.88, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.88, y: 24 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="relative w-10/12 max-w-sm rounded-lg overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={bannerUrl}
              alt="Announcement"
              className="w-full h-auto block"
            />
            <button
              onClick={() => setVisible(false)}
              aria-label="Close banner"
              className="absolute top-3 right-3 p-1.5 bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
